<nav
  #nav
  aria-label="megamenu"
  [cdkTrapFocus]="isBrowser && !isDesktop"
  (keydown)="onKeydown($event)"
  [style.overflow]="navOverflow()"
  [ngClass]="{ 'mobile-opened': mobileOpened(), submenuOpened: submenuOpened }"
>
  <header *transloco="let t">
    <span></span>

    <svg-icon key="logo" fontSize="38px"></svg-icon>

    <button
      app-button="icon-button"
      class="close-button"
      [attr.aria-label]="t('Close menu')"
      (click)="forceClose()"
    >
      <svg-icon key="close"></svg-icon>
    </button>
  </header>

  <ul [style.height]="ulHeight()">
    @for (c of categories | async; track c.name + c.url; let index = $index) {
      <li>
        @if (c.children.length) {
          <button
            [appMegamenuTriggerFor]="megamenuSection"
            class="trigger"
            #trigger
            [attr.aria-expanded]="openedCategoryTrigger() === trigger"
            [attr.aria-controls]="'section' + index"
            (click)="onTriggerClick(trigger)"
          >
            {{ c.label }}
            <svg-icon key="arrow-up" fontSize="20px"></svg-icon>
          </button>
          <section
            [id]="'section' + index"
            #megamenuSection
            app-megamenu-section
            class="category"
            [category]="c"
            (closeMenu)="forceClose()"
            (closeSubmenu)="closeSubmenu()"
          ></section>
        } @else {
          <a
            class="trigger"
            [routerLink]="c.url | addLocale"
            [queryParams]="c.queryParams"
            >{{ c.label }}</a
          >
        }
      </li>
    }
  </ul>
  <footer app-megamenu-footer></footer>
</nav>

@if (isDesktop && openedCategoryTrigger()) {
  <div class="backdrop" (click)="forceClose()"></div>
}
